<script lang="ts" setup>
import SkullIcon from "@/components/icon/SkullIcon.vue";
import { Worldview, Visibility } from "@/types/entity";
import { useAllVisibility } from "@/use/common";
import { useModule } from "@/stores/module";
import { computed } from "vue";

const moduleStore = useModule();

const entity = computed(() => moduleStore.module?.entity);

const VISIBILITIES = useAllVisibility();

const emit = defineEmits<{
  (e: "update:worldview", key: keyof Worldview): void;
}>();
const clickVisibility = (visibility: Visibility) => {
  entity.value!.visibility = visibility;
  emit("update:worldview", "visibility");
};
</script>
<template>
  <div class="py-4 flex flex-col gap-4">
    <div class="flex flex-col gap-2 px-4">
      <div class="text-base-content/50">
        {{ $t("module.worldview.visibility") }}
      </div>
      <div class="flex flex-col gap-2">
        <div
          v-for="item in VISIBILITIES"
          :key="item.value"
          :class="{ checked: entity?.visibility === item.value }"
          class="radio-item"
          @click="clickVisibility(item.value)"
        >
          <label for="public">{{ $t(item.text) }}</label>
          <input
            :checked="entity?.visibility === item.value"
            class="radio radio-xs"
            type="radio"
          />
        </div>
      </div>
    </div>
    <div class="flex flex-col gap-2 px-4">
      <div class="text-error">
        {{ $t("User.mate.visibility.dangerZone") }}
      </div>
      <button
        class="btn btn-error rounded btn-sm"
        @click="moduleStore.module?.deleteEntity"
      >
        <skull-icon class="w-4" />
        {{ $t("module.worldview.delete") }}
      </button>
    </div>
  </div>
</template>
<style scoped>
.radio-item {
  @apply flex justify-between items-center border p-2 rounded text-base-content/50;
}

.radio-item.checked {
  @apply border-base-content text-base-content;
}

.radio-item.checked .radio {
  @apply radio-primary;
}
</style>
